import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

interface AnalyticsState {
  predictions: any[];
  trends: any;
  loading: boolean;
  error: string | null;
}

const initialState: AnalyticsState = {
  predictions: [],
  trends: null,
  loading: false,
  error: null
};

// Mock async thunks (replace with real API calls later)
export const getPredictions = createAsyncThunk(
  'analytics/getPredictions',
  async (currentData: any) => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1000));
    return [
      {
        zone: 'Zone A',
        probability: 0.85,
        estimatedCasualties: 47,
        timeFrame: '6h'
      }
    ];
  }
);

export const getTrends = createAsyncThunk(
  'analytics/getTrends',
  async (timeframe: string) => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 500));
    return {
      totalIncidents: 156,
      averageCasualties: 23,
      byType: { flood: 45, fire: 67, earthquake: 44 }
    };
  }
);

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPredictions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPredictions.fulfilled, (state, action) => {
        state.loading = false;
        state.predictions = action.payload;
      })
      .addCase(getPredictions.rejected, (state) => {
        state.loading = false;
        state.error = 'Failed to get predictions';
      })
      .addCase(getTrends.fulfilled, (state, action) => {
        state.trends = action.payload;
      });
  }
});

export default analyticsSlice.reducer;